import { BASE_QUERY, COMMON_QUERY_CONFIG, ruleNewsPlus, VIDEO_WSJ_NETWORK_QUERY_RULES_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  CYBERSECURITY = 'Cybersecurity'
}

const BASE = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    or: [{ terms: { key: 'SectionType', value: ['cio journal'] } }],
    not: [...BASE_QUERY.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = { ...BASE, count: 2 };

const MAIN = { ...BASE, count: 4 };

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...VIDEO_WSJ_NETWORK_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'Keyword', value: 'WSJ CIO Network 2025' } }],
    not: []
  }
};

const CYBERSECURITY = {
  ...BASE_QUERY,
  query: { ...BASE_QUERY.query, or: [{ terms: { key: 'DJEThing', value: ['tech/cybersecurity'] } }] }
};

const MORE_LIST = { ...BASE };

export { MAIN, SECTION_TOP, VIDEO, CYBERSECURITY, MORE_LIST, SECTION_ENUM };
